// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expired-product-body__prefix[data-v-11743856]{background-color:var(--soldout-color);border-bottom-left-radius:.25rem;border-bottom-right-radius:.25rem;color:var(--white);font-size:.875rem;padding:1rem;text-align:center}.expired-product-body__prefix--taller[data-v-11743856]{margin-left:-1px;margin-right:-1px;margin-top:-1.3rem;padding-top:2rem}.expired-product-body__suffix[data-v-11743856]{border-top:1px solid var(--border-color);padding:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
